import { useState } from "react";
import { buildModalShellTokens } from "./modalShellTheme.js";

function ModalCloseButton({ onClose, ariaLabel, dark, c, A }) {
  const [focused, setFocused] = useState(false);
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      onClick={onClose}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      style={{
        width: 34,
        height: 34,
        borderRadius: 8,
        border: `1px solid ${dark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.08)"}`,
        background: "transparent",
        cursor: "pointer",
        color: c.sub,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        outline: focused ? `2px solid ${A}66` : "none",
        outlineOffset: 2,
        flexShrink: 0,
      }}
      onMouseEnter={(e) => { e.currentTarget.style.background = c.hover; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path d="M18 6 6 18" />
        <path d="m6 6 12 12" />
      </svg>
    </button>
  );
}

export function ModalShellHeader({ title, subtitle, icon, onClose, closeLabel = "Close", titleId, dark, c, A, ap: apProp, trailing }) {
  const ap = apProp ?? buildModalShellTokens(dark, c, A);
  const borderBottom = dark ? "rgba(255,255,255,0.08)" : "rgba(15, 23, 42, 0.07)";

  return (
    <>
      <div aria-hidden style={{ height: 3, flexShrink: 0, background: ap.accentBar }} />
      <div style={{ height: 56, flexShrink: 0, borderBottom: `1px solid ${borderBottom}`, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 20px", background: ap.headerBg, gap: 12 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0, flex: 1 }}>
          {icon ? (
            <div style={{ width: 32, height: 32, borderRadius: 8, background: `linear-gradient(135deg, ${A}33, ${A}18)`, border: `1.5px solid ${A}44`, display: "flex", alignItems: "center", justifyContent: "center", color: A, flexShrink: 0 }}>
              {icon}
            </div>
          ) : null}
          <div style={{ minWidth: 0 }}>
            <h2 id={titleId} style={{ fontSize: 18, fontWeight: 700, color: c.text, margin: 0 }}>{title}</h2>
            {subtitle ? <p style={{ fontSize: 12, color: ap.labelStrong, margin: "2px 0 0", lineHeight: 1.35 }}>{subtitle}</p> : null}
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
          {trailing}
          {onClose ? <ModalCloseButton onClose={onClose} ariaLabel={closeLabel} dark={dark} c={c} A={A} /> : null}
        </div>
      </div>
    </>
  );
}
